import styled from 'styled-components';

export default styled.div`
  font-size: 0.8rem;
  color: #999;
  text-align: center;
`;
